export default "__VITE_ASSET__CAislEp8__"